import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const SITE = 'https://www.sambalup.com';
const BRAND = 'SAMBAL Charitable Trust';
const DEFAULT = {
  title: `${BRAND} | आज का सहयोग, कल का संबल`,
  description: 'संबल चैरिटेबल ट्रस्ट उत्तर प्रदेश — मृत्यु सहायता, कन्या विवाह सहायता और पारस्परिक सहयोग नेटवर्क। मात्र ₹60 वार्षिक सदस्यता।'
};

// Per-route title/description. `noindex` pages are also blocked in robots.txt where they are private.
const PAGES = {
  '/': DEFAULT,
  '/register': {
    title: `सदस्य पंजीकरण | ${BRAND}`,
    description: 'SAMBAL Charitable Trust के सदस्य बनें — मात्र ₹60 वार्षिक सदस्यता से मृत्यु सहायता और कन्या विवाह सहायता का लाभ।'
  },
  '/niyamavali': {
    title: `नियमावली | ${BRAND}`,
    description: 'संबल चैरिटेबल ट्रस्ट की नियमावली — सदस्यता, सहयोग राशि, मृत्यु सहायता और कन्या विवाह सहायता के नियम।'
  },
  '/apply/death-assistance': {
    title: `मृत्यु सहायता आवेदन | ${BRAND}`,
    description: 'सदस्य के निधन पर मृत्यु सहायता के लिए ऑनलाइन आवेदन करें — SAMBAL Charitable Trust, उत्तर प्रदेश।'
  },
  '/gallery': {
    title: `गैलरी | ${BRAND}`,
    description: 'संबल चैरिटेबल ट्रस्ट के कार्यक्रमों और सेवा गतिविधियों की तस्वीरें।'
  },
  '/applications': {
    title: `आवेदन सूची | ${BRAND}`,
    description: 'मृत्यु सहायता और कन्या विवाह सहायता के आवेदनों की पारदर्शी सूची — SAMBAL Charitable Trust।'
  },
  '/members': {
    title: `सदस्य सूची | ${BRAND}`,
    description: 'SAMBAL Charitable Trust के पंजीकृत सदस्यों की सूची।'
  },
  '/login': { title: `लॉगिन | ${BRAND}`, description: DEFAULT.description, noindex: true }
};

const PRIVATE_PREFIXES = ['/dashboard', '/admin', '/super-admin', '/analytics', '/setup', '/admin-register'];

const setMeta = (selector, attr, key, value) => {
  let el = document.head.querySelector(selector);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute('content', value);
};

// Keeps <title>, description, canonical, robots and social tags in step with the current route.
export default function RouteSeo() {
  const { pathname } = useLocation();

  useEffect(() => {
    const path = pathname.length > 1 ? pathname.replace(/\/+$/, '') : pathname;
    const isPrivate = PRIVATE_PREFIXES.some(p => path === p || path.startsWith(`${p}/`));
    const page = PAGES[path] || (isPrivate ? { title: `${BRAND}`, description: DEFAULT.description } : DEFAULT);
    const noindex = isPrivate || page.noindex || (!PAGES[path]); // unknown routes (404) are not indexed
    const url = `${SITE}${path === '/' ? '/' : path}`;

    document.title = page.title;
    setMeta('meta[name="description"]', 'name', 'description', page.description);
    setMeta('meta[name="robots"]', 'name', 'robots', noindex ? 'noindex, nofollow' : 'index, follow');
    setMeta('meta[property="og:title"]', 'property', 'og:title', page.title);
    setMeta('meta[property="og:description"]', 'property', 'og:description', page.description);
    setMeta('meta[property="og:url"]', 'property', 'og:url', url);
    setMeta('meta[name="twitter:title"]', 'name', 'twitter:title', page.title);
    setMeta('meta[name="twitter:description"]', 'name', 'twitter:description', page.description);

    let canonical = document.head.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.setAttribute('rel', 'canonical');
      document.head.appendChild(canonical);
    }
    canonical.setAttribute('href', url);
  }, [pathname]);

  return null;
}
